import { useEffect } from "react";
import { Footer } from "./components/Footer";
import Header from "./components/Header";
import ThankYouEmoji from "./images/thankyouemoji.webp";

export const ThankYou = () => {
  useEffect(() => {
    const returnUrl =
      sessionStorage.getItem("thankYouReturnUrl") || "/";

    const timer = setTimeout(() => {
      sessionStorage.removeItem("thankYouReturnUrl");
      window.location.href = returnUrl;
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Header />

      <section id="retail" className="pt-0">
        <div className="retail">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <div
                  className="title text-center"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  data-aos-duration="600"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                  style={{ paddingTop: "120px" }}
                >
                  <img
                    src={ThankYouEmoji}
                    alt="Thank you"
                    className="thank-you-emoji"
                    style={{
                      width: "220px",
                      height: "150px",
                      objectFit: "contain",
                      display: "block",
                      margin: "0 auto 24px",
                    }}
                  />

                  <h3>Thank You!</h3>

                  <h4>Your form has been submitted.</h4>

                  <p>
                    Our team will get in touch with you shortly. Thanks for
                    choosing Netplus Broadband.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <style>{`
        .thank-you-emoji {
          animation: float-emoji 3s ease-in-out infinite;
        }

        @keyframes float-emoji {
          0% {
            transform: translateY(0px) rotate(0deg);
          }
          25% {
            transform: translateY(-12px) rotate(-4deg);
          }
          50% {
            transform: translateY(0px) rotate(0deg);
          }
          75% {
            transform: translateY(-6px) rotate(4deg);
          }
          100% {
            transform: translateY(0px) rotate(0deg);
          }
        }
      `}</style>
    </>
  );
};